import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { I18nProvider, SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n";
import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/HomePage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import TermsPage from "@/pages/TermsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import ThankYouPage from "@/pages/ThankYouPage";
import "@/App.css";

// Scroll to top on pathname change, but keep scroll on language switches.
// Language switches preserve the sub-path (e.g. /pe/privacy -> /en/privacy),
// so we track the segment after the lang prefix and only scroll when it changes.
function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    const parts = location.pathname.split("/").filter(Boolean);
    const isLangRoot = parts.length <= 1 && SUPPORTED_LANGS.includes(parts[0]);
    const subPath = SUPPORTED_LANGS.includes(parts[0]) ? parts.slice(1).join("/") : parts.join("/");
    const prev = window.__killavoxPrevSubPath;
    window.__killavoxPrevSubPath = subPath;
    if (prev === undefined) {
      // first load — do not force scroll (browser handles)
      return;
    }
    if (prev !== subPath) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    // If prev === subPath => language switch, keep scroll position.
    void isLangRoot;
  }, [location.pathname]);
  return null;
}

function LangRoutes() {
  const { lang } = useParams();
  const safeLang = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
  return (
    <I18nProvider lang={safeLang}>
      <Layout>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="cookies" element={<CookiePolicyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </I18nProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Navigate to="/pe" replace />} />
        <Route path="/thank_you" element={<ThankYouPage />} />
        <Route path=":lang/*" element={<LangRoutes />} />
        <Route path="*" element={<Navigate to="/pe" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
